import { iframeResize } from 'iframe-resizer';

export default () => ({
	init($el) {
		iframeResize({}, $el);
	},
});
